/**
 * @author annie
 */
angular.module('AppCtrl.contact.constant',[ ])
    .constant('constantService',{
        'NOTE_ADDED': i18n["JV_CONTACTCONSTANTS_THE_NOTE_HAS_SUCCESSFULLY_BEEN_ADDED_TO_0_CONTACT_"],
        'TAG_ADDED': i18n["JV_CONTACTCONSTANTS_THE_TAG_HAS_SUCCESSFULLY_BEEN_ADDED_TO_0_CONTACT_S"],
        'MESSAGE_SENT': i18n["JV_CONTACTCONSTANTS_THE_MESSAGE_HAS_SUCCESSFULLY_BEEN_SENT_TO_0_CONTAC"],
        'EXPORT_SUCCESSFUL': i18n["JV_CONTACTCONSTANTS__0_CONTACT_S_HAVE_BEEN_EXPORTED"],
        'ADDED_TO_CAMPAIGN': i18n["JV_CONTACTCONSTANTS__0_CONTACT_S_HAVE_BEEN_ADDED_TO_1_"],
        'MESSAGES_HAS_ERRORS': i18n["JV_CONTACTCONSTANTS_PLEASE_FIX_ALL_THE_ERRORS_BEFORE_SAVING_THE_MESSAG"],
        'MERGE_ERROR': i18n["JV_CONTACTCONSTANTS_PLEASE_SELECT_2_OR_MORE_CONTACTS_TO_MERGE"],
        'EMAIL_ERROR': i18n["JV_CONTACTCONSTANTS_NONE_OF_YOUR_SELECTED_CONTACTS_HAVE_VALID_EMAIL_AD"],
        'SAVED_SEARCH': i18n["JV_CONTACTCONSTANTS_YOUR_SEARCH_HAS_BEEN_SAVED"],
        'FACET_PAGE_SIZE': 5
    });
